//@flow
// Externals
import React from "react";
import { Link } from "raviger";

// Styles
//$FlowFixMe
import "./Button.scss";

/*::
	type Props = {
		onClick?: function,
		label: string,
		questionNumber: string,
		href?: string,
		"data-cy"?: string
	}
*/

const Button = (props /*: Props */) /*: any */ => {
	return (
		<div className={"button-container question-" + props.questionNumber}>
			{props.href && (
				<Link href={props.href}>
					<button
						data-cy={
							props["data-cy"] ||
							"button-q" + props.questionNumber
						}
						onClick={props.onClick}
						disabled={props.disabled}
					>
						{props.label}
					</button>
				</Link>
			)}

			{!props.href && (
				<button
					data-cy={"button-q" + props.questionNumber}
					onClick={props.onClick}
					disabled={props.disabled}
				>
					{props.label}
				</button>
			)}
		</div>
	);
};

// Exports
export default Button;
